import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const StoryPage = lazy(
  () => import('./StoryPage.eager').then(mod => ({default: mod.StoryPage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
